var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[`bg-${_vm.$route.meta.background}`]},[(_vm.isLoading)?_c('Preloader'):_vm._e(),(_vm.$route.meta.eggos !== undefined)?_c('eggos',{attrs:{"color":_vm.$route.meta.eggos}}):_vm._e(),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }